import useResource from 'app/hooks/useResource';

import {
  getAccessCodePages,
  setAccessCodePageParams
} from 'app/actions/accessCodePages';

import {
  createAccessCodePage,
  updateAccessCodePage,
  destroyAccessCodePage
} from 'app/services/accessCodePages';

import {
  accessCodePages as resource
} from 'app/resources';

const useAccessCodePages = () => {
  return useResource({
    resource,
    getResource: getAccessCodePages,
    createResource: createAccessCodePage,
    updateResource: updateAccessCodePage,
    destroyResource: destroyAccessCodePage,
    setResourceParams: setAccessCodePageParams
  });
}

export default useAccessCodePages;
